import React, { useContext, useState, useEffect } from 'react';
import _ from 'lodash';
import Grid from '@mui/material/Grid';
import { SearchBar } from '../../../../components/SearchBar';
import Tree from './components/Tree';
import SmallListMenu from '../../../../components/SmallListMenu';
import { PlaceStoreContext } from '../../../../reducers/Place/PlaceContext';
import { MenuButton } from '../../../../lib/reusable/MenuButton';
import HeaderTag from '../../../../lib/reusable/HeaderTag';
import DigitalMenuPreview from '../../../../components/DigitalMenuPreview';
import { COLORS } from '../../../../utils/colors';

const getCategoryCache = (searching, index) => {
  const nameCategories = [];

  const containsName = index.names.filter((categoryName) =>
    categoryName.includes(searching.trim().toLowerCase()),
  );

  for (const name of containsName) {
    nameCategories.push(index.name__category[name]);
  }

  return nameCategories;
};

const getProductsCache = (searching, index) => {
  const nameProducts = [];

  const containsName = index.names.filter((productName) =>
    productName.includes(searching.trim().toLowerCase()),
  );

  for (const name of containsName) {
    nameProducts.push(index.name__product[name]);
  }

  return nameProducts;
};

const TabMenu = () => {
  const [placeState] = useContext(PlaceStoreContext);
  const [searching, setSearching] = useState('');
  const [searchedProducts, setSearchedProducts] = useState([]);
  const [searchedCategories, setSearchedCategories] = useState([]);
  const [showDigitalMenu, setShowDigitalMenu] = useState(false);
  const [random, setRandom] = useState(0);
  const [services, setServices] = useState([]);
  const [activeService, setActiveService] = useState(null);

  const {
    products: { index: indexProducts },
    categories: { index: indexCategories },
    services: { serviceId__service },
  } = placeState;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setRandom(random + 1);
    setSearching('');
    setSearchedProducts([]);
    setSearchedCategories([]);

    const newServices = [];
    for (const serviceId in serviceId__service) {
      const service = serviceId__service[serviceId];
      const index = Number(service.position) - 1;
      newServices[index] = service;
    }
    setServices(newServices);
    newServices.length > 0 && activeService === null && setActiveService(newServices[0].id);
  }, [placeState]);

  useEffect(() => {
    if (searching.length > 2) {
      const products = getProductsCache(searching, indexProducts);
      products.length > 0 && setSearchedProducts(products);
      const categories = getCategoryCache(searching, indexCategories);
      categories.length > 0 && setSearchedCategories(categories);
    } else {
      searchedProducts.length > 0 && setSearchedProducts([]);
      searchedCategories.length > 0 && setSearchedCategories([]);
    }
  }, [searching]);

  const toggleShowDigitalMenu = () => {
    setShowDigitalMenu(!showDigitalMenu);
  };

  const handleServiceClick = (serviceId) => {
    setActiveService(serviceId);
  };

  if (services.length === 0) {
    return (
      <div className="W100" style={{ margin: '240px 16px 0 16px' }}>
        <h3 className="f2 f12 ta-c">NO SERVICES FOUND, ADD A SERVICE!</h3>
      </div>
    )
  }

  return (
    <div style={{ margin: '40px 16px 0 16px' }}>
      <Grid container style={{ display: 'flex', justifyContent: 'center' }}>
        <Grid item xs={12}>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
            <SearchBar
              searching={searching}
              setSearching={setSearching}
              style={{ height: '36px' }}
              placeholder={`Search in ${serviceId__service[activeService].name} ...`}
            />
          </div>
        </Grid>
        <Grid item xs={12} sm={8} md={6} style={{ marginLeft: '20px' }}>
          <SmallListMenu
            products={searchedProducts}
            categories={searchedCategories}
            visible={searching.length > 2}
          />
        </Grid>
      </Grid>
      {!(searching.length > 2) && (
        <Grid container style={{ display: 'flex', justifyContent: 'center' }}>
          <Grid item xs={12} container spacing={2}>
            <Grid
              item
              xs={12}
              sm={3}
              style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}
            >
              <div style={{ display: 'flex', alignItems: 'center', minHeight: '56px' }}>
                <HeaderTag
                  name={`SERVICES`}
                  color={COLORS.S_DARK_TEXT}
                  size="1rem"
                  style={{ marginBottom: 0 }}
                />
              </div>
              {services.map((service) => (
                <MenuButton
                  key={service.id}
                  action={() => handleServiceClick(service.id)}
                  name={service.name.toUpperCase()}
                  active={activeService === service.id}
                  style={{ minWidth: '160px', padding: '12px 8px 8px 8px' }}
                  gradient="order"
                />
              ))}
            </Grid>
            <Grid item xs={12} sm={6}>
              <Tree serviceId={activeService} />
            </Grid>
            <Grid item xs={12} sm={3} />
          </Grid>
        </Grid>
      )}
      <DigitalMenuPreview showDigitalMenu={showDigitalMenu} toggleShowDigitalMenu={toggleShowDigitalMenu} random={random} />
    </div>
  );
};

export default TabMenu;
